/* eslint-disable no-underscore-dangle */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { push } from 'react-router-redux';
import { identity, path } from 'ramda';

import FSFlatButton from '../../../src/components/lib/FSFlatButton';
import componentBase from '../../../src/lib/component-base';
import { errorMessageForCode } from '../../../src/lib/errors';
import flexErrors from '../../../src/constants/flex-errors';
import { Colors } from '../../../src/constants/style-constants';
import {
  setFlightTrackerSearchError,
  setUniversalSearchFlight,
  setSecondarySearchAction,
  setAdvancedSearchUrl,
} from '../../FlightTracker/redux/Search/actions';
import {
  setSingleFlightSecondarySearchAction,
} from '../../SingleFlight/redux/actions';
import UnifiedSearch from './children/UnifiedSearch/UnifiedSearch';

@connect(state => ({
  error: state.FlightTrackerSearch.error,
  universalSearchFlight: state.FlightTrackerSearch.universalSearchFlight,
  universalSearchValue: state.FlightTrackerSearch.universalSearchValue,
  queryError: state.FlightTrackerSearch.queryError,
  secondarySearchAction: state.FlightTrackerSearch.secondarySearchAction,
}))
@componentBase('FlightSearch')
export default class FlightSearch extends Component {
  static propTypes = {
    dispatch: PropTypes.func,
    error: PropTypes.string,
    gaTitlePrefix: PropTypes.string,
    queryError: PropTypes.string,
    history: PropTypes.object,
    secondaryAction: PropTypes.bool,
    secondarySearchAction: PropTypes.bool,
    title: PropTypes.string,
    universalSearchValue: PropTypes.object,
  };

  constructor(props, context) {
    super(props, context);

    this.submit = this.submit.bind(this);
    this.reportButtonPress = this.reportButtonPress.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.secondarySearchAction) {
      /*
        secondary search gets fired only once
        (the render cycle where this condition is true)
      */
      nextProps.dispatch(setSecondarySearchAction(false));
    }
  }

  componentWillUnmount() {
    const { dispatch } = this.props;
    // clear error message
    dispatch(setFlightTrackerSearchError(null));
    dispatch(setSecondarySearchAction(false));
  }

  advancedSearchClick = () => {
    this.reportButtonPress('GoToAdvancedSearch');
    this.props.dispatch(setFlightTrackerSearchError(null));
  }

  validate = () => {
    const { universalSearchValue } = this.props;
    if (!universalSearchValue) { return 'UNIVERSAL_SEARCH_EMPTY'; }
    return null;
  };

  submit(e) {
    e && e.preventDefault();

    const {
      dispatch,
      history,
      universalSearchValue = {},
    } = this.props;

    const errorCode = this.validate();
    dispatch(setFlightTrackerSearchError(errorCode));

    const destination = universalSearchValue && universalSearchValue.url;

    if (!errorCode && destination) {
      dispatch(setUniversalSearchFlight({
        flight: '',
        label: '',
        url: '',
      }));

      // reset search triggers
      dispatch(setSingleFlightSecondarySearchAction(true));
      dispatch(setAdvancedSearchUrl(''));
      const topOfStackHistory = path(['location', 'pathname'], history);
      if (destination && topOfStackHistory !== destination) {
        // multiple identical entries were being pushed into history on enter
        dispatch(push(destination));
      }
    }
  }

  reportButtonPress = (label) => {
    this.context.reportButtonPress(`${this.props.gaTitlePrefix}-${label}`);
  }

  render = () => {
    const {
      error,
      queryError,
      title,
    } = this.props;

    let errorBlock = '';
    const errorText = (error && flexErrors(error)) ||
      (queryError && errorMessageForCode(queryError));

    if (errorText) {
      errorBlock = (
        <div className='search-error-text-block'>
          <p className='search-error-text'>{errorText}</p>
        </div>
      );
    }

    let titleBlock = '';
    if (title) {
      titleBlock = <h3 className='flight-search-title'>{title}</h3>;
    }

    return (
      <section className='FlightSearch'>
        <div className='flight-search-container'>
          <div className='fs-search'>
            <form onSubmit={this.submit}>
              <div>
                {titleBlock}
                {errorBlock}
                <p className='landing-text'>Enter your flight information</p>
              </div>
              <UnifiedSearch
                {...this.props}
                secondaryAction={
                  this.props.secondarySearchAction ? this.submit : identity
                }
              />
              <div className='row'>
                <div className='col-xs-12 col-sm-5 center-buttons-mobile' style={{ marginTop: '15px' }}>
                  <FSFlatButton
                    label='Search'
                    type='submit'
                    className='flight-tracker-search-button'
                    onClick={() => this.reportButtonPress('Search')}
                    primary
                  />
                </div>
                <div className='col-xs-12 col-sm-5 col-sm-offset-2 center-buttons-mobile' style={{ marginTop: '15px' }}>
                  <Link to='/flight-tracker/search/advanced'>
                    <FSFlatButton
                      label='Advanced Search &gt;'
                      style={FSFlatButton.style({ color: 'white' })}
                      backgroundColor={Colors.blue6}
                      hoverColor={Colors.blue8}
                      className='flight-tracker-adv-search-button'
                      onClick={this.advancedSearchClick}
                    />
                  </Link>
                </div>
              </div>
            </form>
          </div>
        </div>
      </section>
    );
  }
}
/* eslint-enable no-underscore-dangle */



// WEBPACK FOOTER //
// ./modules/FlightSearch/components/container.js